import axios from "axios";
import { applyRequestHmac } from './hmacUtils';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const apiRequest = async (endpoint, method, data = null, headers = {}) => {
  const url = `${API_BASE_URL}/${endpoint}`;
  const options = {
    url,
    method,
    headers: {
      ...(data instanceof FormData ? {} : { "Content-Type": "application/json" }),
      ...headers,
    },
  };

  if (data) {
    options.data = data;
  }

  applyRequestHmac(options);

  try {
    const response = await axios(options);
    return response;
  } catch (error) {
    if (error.response?.status == 401) {
      localStorage.removeItem("token");
    }
    console.error("API request failed:", error);
    throw error;
  }
};
